import React, {Component} from 'react';
import styles from './AgentAvatar.scss';
import PropTypes from 'prop-types';

class AgentAvatar extends Component {
  render() {
    let avatarUrl = '/assets/images/profile_icon.svg';
    if (this.props.avatarUrl) {
      avatarUrl = this.props.avatarUrl;
    }
    let contentJsx =
      <div>
        <div className={styles.agentAvatar + ' ' + (this.props.size ? styles[this.props.size]: '')}>
          <img className={styles.agentImage} src={avatarUrl} width="300" alt="agent headshot" />
        </div>
        { this.props.agentName ?
          <span className={"smText " + styles.agentName}>
            {this.props.agentName}
          </span> : null
        }
      </div>;
    return (
      (this.props.agentLink) ?
        <a className="d-flex flex-column text-center" href={this.props.agentLink}>
          {contentJsx}
        </a>
        :
        contentJsx
    );
  }
}

AgentAvatar.propTypes = {
  avatarUrl: PropTypes.string,
  agentLink: PropTypes.string,
  agentName: PropTypes.string,
  size: PropTypes.string,
}

export default AgentAvatar;
